<template>
  <div>
    <h4>{{title}}</h4>
    <Doughnut 
      :chart-data="declaration"
      :height="130" />
  </div>
</template>

<script>

import Doughnut from '../../store/Graficos/Doughnut'

export default {
  components: {
    Doughnut
  },
  data(){
    return {
      
    }
  },
  mounted () {
  },
  props:{
    title:{
      type: String
    },
    declaration:{
      type: Object
    }
  },
  methods: {
  }
}
</script>

